import React, { forwardRef, useImperativeHandle, useState } from "react";
import PropTypes from "prop-types";

export const ModalWindow = forwardRef(({ isActive = false, children }, ref) => {
  const [isModalActive, setIsModalActive] = useState(isActive);

  const openModal = (e, propagation) => {
    if (propagation === "stop") {
      e.stopPropagation();
    }
    setIsModalActive(true);
    fixWindowScrollPosition();
  };

  const closeModal = (e, propagation) => {
    if (propagation === "stop") {
      e.stopPropagation();
    }
    setIsModalActive(false);
    releaseWindowScrollPosition();
  };

  useImperativeHandle(ref, () => ({
    openModal,
    closeModal,
  }));

  return children(openModal, closeModal, isModalActive);
});

const fixWindowScrollPosition = () => {
  const scrollPosition = $(window).scrollTop();
  $("body").addClass("fixed").css({ top: -scrollPosition });
};

const releaseWindowScrollPosition = () => {
  const scrollPosition = Math.abs(parseInt($("body").css("top"), 10));
  $("body").removeClass("fixed").css({ top: 0 });
  window.scrollTo(0, scrollPosition);
};

export function Modal({ isActive, closeModal, width, className, children }) {
  const handleClose = () => {
    closeModal();
  };

  const stopClose = (e) => {
    e.stopPropagation();
  };

  const how_to_display = isActive ? "block" : "none";
  const modalBlockerStyle = {
    display: how_to_display,
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 100,
    background: "rgba(0, 0, 0, 0.75)",
    overflow: "auto",
  };
  // NOTE: 中央寄せはネガティブマージンではなく transform で行う。
  //       ネガティブマージン方式はウィンドウ幅がモーダル幅より狭いとき左側が
  //       スクロール不能な画面外（scrollLeft < 0 の領域）にはみ出して見切れるため、
  //       maxWidth と併せてウィンドウ内に収める（モーダル内スクロールに逃がす）
  const modalBoxStyle = {
    position: "absolute",
    display: "table",
    height: "100%",
    zIndex: 1000,
    left: "50%",
    transform: "translateX(-50%)",
    width,
    maxWidth: "100%",
    opacity: 1,
  };
  const modalHeightSetter = {
    display: "table-cell",
    verticalAlign: "middle",
  };

  return (
    <div
      style={modalBlockerStyle}
      onClick={handleClose}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter") handleClose();
      }}
    >
      <div
        className="manageModalBox"
        style={modalBoxStyle}
        onClick={stopClose}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter") stopClose(e);
        }}
      >
        <div className="modalHeightSetter" style={modalHeightSetter}>
          <div className={className}>{children}</div>
        </div>
      </div>
    </div>
  );
}

ModalWindow.propTypes = {
  isActive: PropTypes.bool,
  children: PropTypes.func.isRequired,
};

ModalWindow.defaultProps = {
  isActive: false,
};

Modal.propTypes = {
  isActive: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  width: PropTypes.number.isRequired,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Modal.defaultProps = {
  className: "",
};
